import React from 'react';
import '../styles/contactme.css'; 

const ContactMe = () => {
  return (
    <div className="contactme">
      <h2>Contact me</h2>
      
      <div className="contact-info">
        <p>Thank you for taking the time to explore my website! I value your interest and would love to hear from you. Whether you have a business proposal or question, feedback, partnership    request or only just want to say hello, this is the place to connect with me.</p>
        <p>E-mail: <a href="mailto:gunayshakhmuradova@gmail.com">gunayshakhmuradova@gmail.com</a> </p>
      </div>
    </div> 
  );
};

export default ContactMe;
